import React from "react";

import PropTypes from "prop-types";

export default function Label({
  children,
  className = "",
  required = false,
  horizontalInput = false,
  noMarginBottom = false,
  dark = false,
  ...labelProps
}) {
  let classNames = null;
  let textColor = "text-white";

  if (horizontalInput) {
    classNames = "pt-1";
  } else if (!noMarginBottom) {
    classNames = "mb-3";
  }

  if (dark) {
    textColor = "text-gray-900";
  }

  return (
    <label
      className={`inline-block font-medium text-lg ${textColor} ${className} ${classNames}`}
      {...labelProps}
    >
      {children} {required && " *"}
    </label>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  required: PropTypes.bool,
  horizontalInput: PropTypes.bool,
  noMarginBottom: PropTypes.bool,
};
